module.exports = __webpack_public_path__ + "static/media/pa-logo.d199718c.svg";